export default {
  gameSummary: {
    sections: {
      matchupInformation: "Información del enfrentamiento",
      rankings: "Rankings",
    },
    labels: {
      record: "Récord",
      rank: "Ranking",
      type: "Tipo",
      stat: "Estadística",
      filterByGame: "Filtrar por partido",
      position: "Posición",
      injury: "Lesión",
      status: "Estado",
      trend: "Tendencia",
    },
    standingTypes: {
      division: "División",
      conference: "Conferencia",
      league: "Liga",
      overall: "General",
    },
    rankingSides: {
      FOR: "A FAVOR",
      AGAINST: "EN CONTRA",
    },
    statAbbreviations: {
      PTS: "PTS",
      "SCORE %": "% ANOT.",
      "SCORE%": "% ANOT.",
      PLAYS: "JUG.",
      "NET YDS": "YDS NETAS",
      "PASS YDS": "YDS PASE",
      "PASS ATT": "INT. PASE",
      "PASS COMPL": "PASES COMP.",
      "PASS TD": "TD PASE",
      "RUSH YDS": "YDS CARR.",
      "RUSH ATT": "INT. CARR.",
      "RUSH TD": "TD CARR.",
      "TOTAL TDS": "TD TOTAL",
      "RZ%": "% ZR",
      "1D": "1D",
      "3D%": "% 3D",
      "4D%": "% 4D",
      INT: "INT",
      TO: "PERD.",
      SACKS: "CAPT.",
      FUML: "BAL. PERD.",
      G: "G",
      SOG: "TAP",
      SAT: "INT. TIRO",
      "CF%": "% CF",
      "PP%": "% PP",
      PIM: "MIN. PEN.",
      PPG: "G PP",
      SHG: "G INF.",
      "SH%": "% INF.",
      BLK: "BLOQ.",
      FTM: "TL CONV.",
      FTA: "TL INT.",
      "FT%": "% TL",
      FGM: "TC CONV.",
      FGA: "TC INT.",
      "FG%": "% TC",
      "3PTM": "3P CONV.",
      "3PTA": "3P INT.",
      "3PT%": "% 3P",
      "TS%": "% TS",
      "eFG%": "% eFG",
      TRB: "REB",
      AST: "AST",
      STL: "ROB",
      R: "C",
      H: "H",
      "1B": "1B",
      "2B": "2B",
      "3B": "3B",
      TB: "BT",
      ER: "CL",
      HR: "HR",
      RBI: "CI",
      BB: "BB",
      SO: "PON.",
      E: "E",
      AVG: "AVG",
      OBP: "OBP",
      SLG: "SLG",
      OPS: "OPS",
      POS: "POS.",
      SHO: "TIR.",
      SOT: "TAP",
      COR: "CÓR.",
      OFF: "FJ",
      FLS: "FAL.",
      "2YELRED": "2A+R",
      YEL: "AMAR.",
      RED: "ROJ.",
      T: "T",
      "CR%": "% COMP.",
      RM: "M CARR.",
      LB: "RUP.",
      K: "PAT.",
      KM: "M PAT.",
    },
    quickPicks: {
      moneyline: "Ganador",
      spread: "Hándicap",
      total: "Total",
    },
  },
};